var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCredentialPackages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4066_4354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.59298 17.2768L18.8759 17.207C19.1527 17.207 19.7476 16.4236 19.845 16.1645L22.2822 9.66018C22.4438 9.23044 21.5667 8.42041 21.1076 8.41217H4.94198C4.64157 8.40692 4.3996 8.75968 4.23734 9.05805L1.46447 15.1353C1.0926 15.9504 1.4902 16.9145 2.33237 17.22C2.43229 17.2562 2.52172 17.2768 2.59298 17.2768Z",
    stroke: "#E5E7EB",
    strokeWidth: 1.39678,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.941014 15.9884L0.69873 3.1045C0.69873 3.1045 0.809002 0.725776 3.58386 1.01222L6.38614 0.995417C7.42296 0.989168 7.95856 0.915234 8.77415 1.55549C8.9487 1.69249 9.58282 2.25136 9.70648 2.3997C10.5437 3.40334 11.7971 3.40486 12.4571 3.32084C12.8972 3.26513 13.3405 3.23866 13.7841 3.2416L16.9523 3.25883C16.9523 3.25883 18.6188 3.4642 18.5089 6.4741",
    stroke: "#E5E7EB",
    strokeWidth: 1.39678,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.258301 15.9874C0.258301 15.9874 0.493233 17.1914 1.57957 17.4336C2.66591 17.6759 1.21252 15.7305 1.21252 15.7305L0.258301 15.9874Z",
    fill: "#E5E7EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4066_4354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 17.6853,
    fill: "white",
    transform: "translate(0 0.289062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredentialPackages);
export default __webpack_public_path__ + "static/media/credential-packages.d761d37e1ac03db0d5c66816245d766b.svg";
export { ForwardRef as ReactComponent };